import { h } from 'preact';
export const Database = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("ellipse", { cx: "12", cy: "5", rx: "9", ry: "3" }),
        h("path", { d: "M21 12c0 1.66-4 3-9 3s-9-1.34-9-3" }),
        h("path", { d: "M3 5v14c0 1.66 4 3 9 3s9-1.34 9-3V5" })));
};
//# sourceMappingURL=database.js.map